import headerLogo from './js/widgets/headerLogo.js';
import secondaryThemeWidget from './js/helpers/hcSubPage.js';
import customFeatureLineUp from './js/helpers/featureLineUp.js';
import countdownContent from './js/widgets/countdownContent.js';
import customCountdown from './js/helpers/SiteInfoBanner.js';
import cardWidgetVideo from './js/widgets/cardWidgetVideo.js';
import seoWidget from './js/widgets/seoWidget.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import eventCards from './js/widgets/eventCards.js';
import signupModule from './js/widgets/signupModule.js';
import footerLogos from './js/widgets/footerLogos.js';
import footerBackground from './js/widgets/footerBackground.js';
import sponsors from './js/widgets/sponsors.js';

import './js/localjs.js';
import './js/helpers/customNav.js';

$(document).ready(function () {
  headerLogo();
  secondaryThemeWidget();
  customFeatureLineUp();
  sponsors();
  footerBackground();
  footerLogos();

  if (window.location.pathname === '/') {
    cardWidgetVideo()
    countdownContent();
    customCountdown();
    seoWidget()
    multiScheduleFeature();
    eventCards();
    signupModule();
  }
});